
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
XHeader,
Tab,
TabItem,
Swiper,
SwiperItem,
Group,
Cell
},
data() {
return {
errType: this.$route.query.type,
tabIndex: 0,
courseChapterList: [],
errorListNumber: [],
errorListCycle: []
};
},
created() {
this.getData();
},
methods: {
getData() {
this.$http({
method: "post",
url: "wxexam.ashx?op=LoadChapterListForSelectSubject",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
showTime: this.GLOBAL.SubjectShowTime.TestInError,
errType: this.errType
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.courseChapterList = response.data.data;
}
})
.catch(function(error) {
console.log("error:" + error);
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadErrSubjectGroupList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
showObj: 0,
errType: this.errType
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.errorListNumber = response.data.data;
}
})
.catch(function(error) {
console.log("error:" + error);
});

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadErrSubjectGroupList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.$store.getters.getClassInfo.CourseId,
showObj: 1,
errType: this.errType
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.errorListCycle = response.data.data;
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
clickCourseChapter(course) {

this.$router.push({
path: "/ChapterSubjectList",
query: {
showtime: this.GLOBAL.SubjectShowTime.TestInError,
errtype: this.errType,
errobj: this.GLOBAL.SubjectErrObj.Chapter,
errvalue: course.ichapterid,
chapterid:course.ichapterid,
title:course.cchaptername
}
});









},
clickErrorNumber(item) {
this.$router.push({
path: "/SubjuectData",
query: {
showtime: this.GLOBAL.SubjectShowTime.TestInError,
errtype: this.errType,
errobj: this.GLOBAL.SubjectErrObj.Number,
errvalue: item.iwrong
}
});
},
clickErrorCycle(item) {
this.$router.push({
path: "/SubjuectData",
query: {
showtime: this.GLOBAL.SubjectShowTime.TestInError,
errtype: this.errType,
errobj: this.GLOBAL.SubjectErrObj.Cycle,
errvalue: item.iperiod
}
});
}
},
computed: {
swiperHeight: function() {
return document.documentElement.clientHeight - 90 + "px";
}
}
};



// WEBPACK FOOTER //
// ./src/components/ErrorList.vue